/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeValue
 */
export interface AttributeValue {
    /**
     * 
     * @type {string}
     * @memberof AttributeValue
     */
    valueOriginal?: string;
}

export function AttributeValueFromJSON(json: any): AttributeValue {
    return AttributeValueFromJSONTyped(json, false);
}

export function AttributeValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueOriginal': !exists(json, 'valueOriginal') ? undefined : json['valueOriginal'],
    };
}

export function AttributeValueToJSON(value?: AttributeValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valueOriginal': value.valueOriginal,
    };
}


